export function handleExpansionPanel(selector) {
	if (typeof selector === 'object') {
		var $cont = selector.find('[expansion-panel]');
	} else {
		var $cont = $(selector + ' [expansion-panel]');
	}

	$cont.each(function (idx) {
		let $div = $(this);

		$div.kendoExpansionPanel({
			title: $div.data('title'),
		});
	});

}
